import { Alert, Box, Grid, Theme, useTheme } from "@mui/material";
import NavCard from "components/NavCard";
import useGlobalContext from "hooks/globalData";
import useTitle from "hooks/useTitle";
import { kebabCase } from "lodash";
import { FormattedMessage as T, useIntl } from "react-intl";
import { useQuery } from "react-query";
import { OrganizationAttributeTypeRequest } from "services/KnowfullyAdminClient";
import contextStore from "stores/contextStore";

const useStyles = (theme: Theme) => ({
  feedback: {
    width: "100%",
    margin: "20px 0 20px 0",
  },
});

export const AttributesPage = () => {
  const { attributeService, attributesUrl } = useGlobalContext();
  const { organizationId } = contextStore.useState();
  const styles = useStyles(useTheme());
  const { formatMessage: t } = useIntl();

  useTitle(t({ id: "attributes" }));

  const isAttributeManagementAvailable = true;

  const request = OrganizationAttributeTypeRequest.fromJS({
    sortField: "name",
    organizationId,
    parameters: { isAttributeManagementAvailable },
  });

  const fetchedOrganizationAttibuteTypes = useQuery(
    ["getOrganizationAttributeTypes", request],
    () => attributeService.getOrganizationAttributeTypes(request)
  );

  const organizationAttributeTypes =
    fetchedOrganizationAttibuteTypes.data?.data || [];

  if (
    !fetchedOrganizationAttibuteTypes.isLoading &&
    organizationAttributeTypes.length === 0
  ) {
    return (
      <Alert sx={styles.feedback} severity="warning">
        <T id="noAttributeTypesForOrganization" />
      </Alert>
    );
  }

  return (
    <Box my={4}>
      <Grid container spacing={4}>
        {organizationAttributeTypes
          .sort((a, b) => a.displayName!.localeCompare(b.displayName!))
          .map((attr) => {
            const routeUrl = `${attributesUrl()}/by-type/${kebabCase(
              attr.attributeType?.codeConstant ?? "unknown"
            )}`;
            return (
              <Grid item xs={12} sm={4} key={routeUrl}>
                <NavCard title={attr.displayName!} url={routeUrl} />
              </Grid>
            );
          })}
      </Grid>
    </Box>
  );
};

export default AttributesPage;
